<template>
    <div>
		<compSteplist v-if="boxtype == 'inbound' && inboundNodeList.length !== 0" :nodeList="inboundNodeList"></compSteplist>
        <div>{{$t('fbb.headlogistics.headlogistics_order_number', { defaultValue: '头程物流单号' })}} {{formData.preLogisticsNo}}</div>
        <Table style="overflow:auto" class="margin-top-10" :columns="columns" :data="dataList"></Table>
        <div>
            <div class="margin-top-15" v-for="(item,index) in inboundList" :key="index">
                <div>{{$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })}}:{{item.subLogisticNo}}</div>
                <Table
                    style="overflow:auto"
                    class="margin-top-10"
                    :columns="columns"
                    :data="item.subLogisticsRecordEntities"
                ></Table>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpSeeLogisticsHistory, HttpSeeLogisticsOne } from "@/service/headlogistics";
import { HttpInboundHeadLogistics, HttpInboundSubscribe } from "@/service/inbound";
import mixinlist from "./mixin";
import compSteplist from './nodelist';

export default {
    mixins: [mixinlist],
    props: ["orderid", "boxtype", "seedetail"],
	components: {
		compSteplist,
    },
    data() {
        return {
            btnList: [],
            dataList: [],
            inboundList: [],
            inboundNodeList: [],
            formData: {},
            keyList: {
                extra_pallet_date: this.$t('fbb.headlogistics.pallet_date', { defaultValue: "入仓打托日期" }),
                extra_clear_date: this.$t('fbb.headlogistics.customer_clearance_date', { defaultValue: "清关日期" }),
                extra_arrive_date: this.$t('fbb.headlogistics.arrival_at', { defaultValue: "到港日期" }),
                extra_realsail_date: this.$t('fbb.headlogistics.actual_sail_at', { defaultValue: "实际开船日期" }),
                extra_declare_date: this.$t('fbb.headlogistics.declare_date', { defaultValue: "报关日期" }),
                extra_tax_number: this.$t('fbb.headlogistics.customer_tax_no', { defaultValue: '税号' }),
                extra_cutoff_date: this.$t('fbb.headlogistics.cutoff_date', { defaultValue: "截关日期" }),
                extra_price: this.$t('fbb.headlogistics.price', { defaultValue: "运费报价" }),
                extra_book_date: this.$t('fbb.headlogistics.book_date', { defaultValue: "预约日期" }),
                extra_stockin_date: this.$t('fbb.headlogistics.stock_in', { defaultValue: "妥投日期" }),
                carrier_op_id: this.$t('fbb.headlogistics.forwarder_incharge', { defaultValue: "货代负责人" }),
                extra_expectsail_date: this.$t('fbb.headlogistics.estimate_sail_at', { defaultValue: "预计开船日期" }),
                extra_invoiceconfirm_date: this.$t('fbb.headlogistics.invoice_confirm_date', { defaultValue: "发票确认日期" }),
                extra_logistics_no: this.$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: "物流单号" }),
                extra_forwardstockin_date: this.$t('fbb.headlogistics.forwards_stockin_date', { defaultValue: "中转仓到达日期" }),
                extra_sending_date: this.$t('fbb.headlogistics.sending_date', { defaultValue: "送仓日期" }),
                purpose_port: this.$t('fbb.headlogistics.purpose_port', { defaultValue: "目的港口" }),
                purposeport_title: this.$t('fbb.headlogistics.purpose_port', { defaultValue: "目的港口" }),
                currency: this.$t('global.common.currency', { defaultValue: "币种" }),
                price: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
                extra_deststockin_date: this.$t('fbb.headlogistics.dest_stockin_date', { defaultValue: "目的仓到达日期" }),
                deny_reason: this.$t('fbb.headlogistics.deny_reason', { defaultValue: "退回原因" }),
                extra_expectarrive_date: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: "预计到港日期" }),
                cancel_reason: this.$t('fbb.headlogistics.cancel_reason', { defaultValue: "取消原因" }),
                transport_type: this.$t('fbb.headlogistics.transport_type', { defaultValue: "发运方式" }),
                declare_invoice_src: this.$t('fbb.headlogistics.declare_invoice', { defaultValue: "报关单据-invoice" }),
                // declare_invoice_url:'报关单据-invoice',
                packing_src: this.$t('fbb.headlogistics.packing_src', { defaultValue: "报关单据-packing list" }),
                // packing_url:'报关单据-packing list',
                order_src: this.$t('fbb.headlogistics.order_src', { defaultValue: "订舱单" }),
                // order_url:'订舱单',
                invoice_src: this.$t('fbb.headlogistics.attach_src_invoice', { defaultValue: "发票" }),
                pod_src: 'pod',
                // invoice_url:'发票',
                other_carrier_total_cost: this.$t('fbb.headlogistics.deliver_total_cost', { defaultValue: '运费总计' }),
                total_cost: this.$t('fbb.headlogistics.deliver_total_cost', { defaultValue: '运费总计' }),
                china_cost: this.$t('fbb.headlogistics.cost_china', { defaultValue: '中国段费用' }),
                tariff: this.$t('fbb.headlogistics.tariff', { defaultValue: '关税' }),
                ocean_freight: this.$t('fbb.headlogistics.cost_sea', { defaultValue: '海运费' }),
                other_carrier_deststockin_date: this.$t('fbb.headlogistics.dest_stockin_date', { defaultValue: "目的仓到达日期" }),
                recovery: this.$t('fbb.headlogistics.huifuzhengchang', { defaultValue: "恢复正常" }),
                destination_cost: this.$t('fbb.headlogistics.destination_cost', { defaultValue: "目的国费用" }),
                extra_cabinet_20GP: this.$t('fbb.headlogistics.logistics_20gp_number', { defaultValue: "20尺柜(20GP)数量" }),
                extra_cabinet_20GP_qty: this.$t('fbb.headlogistics.logistics_20gp_number', { defaultValue: "20尺柜(20GP)数量" }),
                extra_cabinet_20GP_no: this.$t('fbb.headlogistics.logistics_20gp_container_number', { defaultValue: "20尺柜(20GP)集装箱号" }),
                extra_cabinet_40GP: this.$t('fbb.headlogistics.logistics_40gp_number', { defaultValue: "40尺柜(40GP)数量" }),
                extra_cabinet_40GP_qty: this.$t('fbb.headlogistics.logistics_40gp_number', { defaultValue: "40尺柜(40GP)数量" }),
                extra_cabinet_40GP_no: this.$t('fbb.headlogistics.logistics_40gp_container_number', { defaultValue: "40尺柜(40GP)集装箱号" }),
                extra_cabinet_40HQ_no: this.$t('fbb.headlogistics.logistics_40hq_container_number', { defaultValue: "40尺高柜(40HQ)集装箱号" }),
                extra_cabinet_40HQ_qty: this.$t('fbb.headlogistics.logistics_40hq_number', { defaultValue: "40尺高柜(40HQ)数量" }),
                extra_cabinet_45HQ_no: this.$t('fbb.headlogistics.logistics_45hq_container_number', { defaultValue: "45尺高柜(45HQ)集装箱号" }),
                extra_cabinet_45HQ_qty: this.$t('fbb.headlogistics.logistics_45hq_number', { defaultValue: "45尺高柜(45HQ)数量" }),
                total_vol: this.$t('fbb.headlogistics.total_volumn', { defaultValue: "总体积" }),
                exception_status: this.$t('fbb.headlogistics.exception_status', { defaultValue: "异常状态" }),
                exception_notice: this.$t('fbb.headlogistics.yichangtixing', { defaultValue: "异常提醒" }),
                qty_exception: this.$t('fbb.headlogistics.qty_exception', { defaultValue: "总箱数更改" }),
                weight_exception: this.$t('fbb.headlogistics.weight_exception', { defaultValue: "总重量更改" }),
                volume_exception: this.$t('fbb.headlogistics.volume_exception', { defaultValue: "总体积更改" }),
                error_msg: this.$t('fbb.headlogistics.error_msg', { defaultValue: "更改明细" }),
                clear_packing_list_src: "Packing List",
                // clear_packing_list_url:'Packing List',
                clear_invoice_src: "Invoice",
                // clear_invoice_url:'Invoice',
                clear_shipping_label_src: "Shipping Label",
                // clear_shipping_label_url:'Shipping Label',
                sail_order_src: this.$t('fbb.headlogistics.attach_sail_order', { defaultValue: "提单" }),
                // sail_order_url:'提单',
                check_order_src: this.$t('fbb.headlogistics.check_order', { defaultValue: "查验凭证" }),
                // check_order_url:'查验凭证',
                voyage_name: this.$t('fbb.headlogistics.voyage_name', { defaultValue: '船名航次' }),
                forwarder_name: this.$t('fbb.headlogistics.forwarder', { defaultValue: "货代公司" }),
                confirm_status: this.$t('fbb.headlogistics.confirm_status', { defaultValue: "确认发货状态" }),
                expect_stockin_at: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: "预计到仓日期" }),
                // forwarder_warehouse_code: "中转仓确认",
                // importer_id: "进口商id",
                // ship_port_id: "发运港id",
                other_extra_expectarrive_date: this.$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: "预计到港日期" }),
                other_expect_stockin_at: this.$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: "预计到仓日期" }),
                // carrierport_id: "发运港口",
                actual_loading_date: this.$t('fbb.headlogistics.actual_loading_date', { defaultValue: "实际装柜日期" }),
                // purpose_port_id: "目的港口id",
                extra_cutoff_order_date: this.$t('fbb.headlogistics.cutoff_order_date', { defaultValue: "截单日期" }),
                // forwarder_id: "货代公司id",
                ship_port: this.$t('fbb.headlogistics.ship_port', { defaultValue: "发运港" }),
                // extra_audit_action: "审核类型",
                extra_reserve_delivered_date: this.$t('fbb.headlogistics.appointment_at', { defaultValue: "预约送仓时间" }),
                // extra_cabinet_20GP_qty: '20GP数量',
                // extra_cabinet_20GP_qty_no: '20GP集装箱号',
                // extra_cabinet_40GP_qty
                forwarder_warehouse_name: this.$t('fbb.headlogistics.forwarder_warehouse_name', { defaultValue: "中转仓名称" }),
                // forwarder_warehouse_code: "中转仓code",
                logistics_type: this.$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' }),
                inbounds: this.$t('fbb.headlogistics.container_data', { defaultValue: '集装箱数据' }),
                extra_other_carrier_total_cost: this.$t('fbb.headlogsitics.carrier_total_cost', { defaultValue: '实际运费' }),
                importer_name: this.$t('fbb.headlogtics.importer', { defaultValue: '进口商' }),
                // id: '入库单号',
                can_cabinet_date: this.$t('fbb.headlogistics.can_cabinet_date', { defaultValue: '可提柜时间' }),
                cost_explain: this.$t('fbb.headlogistics.cost_explain', { defaultValue: '费用说明' }),
                agent_payment_term: this.$t('bi.paymentterm.payment_term', { defaultValue: '付款周期'}),
                other_estimate_cost: this.$t('fbb.headlogistics.other_cost', { defaultValue: '其他费用' }),
                invoice_no: this.$t('erp.b2border.invoice', { defaultValue: '发票号' }),
                china_estimate_cost: this.$t('fbb.headlogistics.expect_china_cost', { defaultValue: '中国段费用' }),
                destination_estimate_cost: this.$t('fbb.headlogistics.destination_cost', { defaultValue: '目的国费用' }),
                ocean_freight_estimate: this.$t('fbb.headlogistics.expect_sea_delivery_cost', { defaultValue: '预估海运费' }),
                tariff_estimate: this.$t('fbb.headlogistics.tariff', { defaultValue: '关税' }),
                bound: 'Bound',
                order_id: this.$t('fbb.headlogistics.forward_order_id', { defaultValue: "货代单号" })
            },
        };
    },
    created() {
        this.btnList = this.buttonList(null, null, null, null, null, true);
        this.update();
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t('global.common.operate_type', { defaultValue: "操作类型" }),
                    key: "index",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{this.getLogistics(row.type)}</div>
                            </div>
                        );
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.order_status', { defaultValue: "单据状态" }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    {this.getOrderstatus(row.orderStatus)}
                                </div>
                            </div>
                        );
                    }
                },
                {
                    title: this.$t('global.common.operator', { defaultValue: "操作人" }),
                    key: "opName"
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: "操作时间" }),
                    key: "operateAt"
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: "备注" }),
                    key: "memo"
                },
                {
                    title: this.$t('fbb.headlogistics.attach_info', { defaultValue: "附加信息" }),
                    key: "receivedQty",
                    width: 280,
                    render: (h, { row }) => {
                        // 遍历对象
                        let arrkey = [];
                        for (var key in row.additionData) {
                            // if (
                            //     key != "order_url" &&
                            //     key != "declare_invoice_url" &&
                            //     key != "packing_url" &&
                            //     key != "sail_order_url" &&
                            //     key != "clear_packing_list_url" &&
                            //     key != "clear_invoice_url" &&
                            //     key != "clear_shipping_label_url" &&
                            //     key != "check_order_url" &&
                            //     key != "invoice_url" &&
                            //     key != "sail_order_url" &&
                            //     key != "invoice_url" &&
                            //     key != "order_url"
                            // ) {
                                arrkey.push(key);
                            // }
                        }
                        arrkey = new Set(arrkey)
                        let keys
                        // 根据操作类型判断字段是否需要
                        switch (row.type) {
                            // case 0:
                            //     let delArr = [
                            //         'extra_logistics_no',
                            //     ]
                            //     keys = this.handleRender(h, row, arrkey, delArr)
                            // break;
                            // // 已创建
                            // case 1:
                            //     break;
                            // // 提交
                            // case 2:
                            //     break;
                            // 审核
                            case 3:
                            {
                                let delArr = [
                                    'extra_logistics_no',
                                ]

                                let needAdd = false
                                if (this.carrierType === 1 && this.logisticsType === 'transfer') {
                                    needAdd = true
                                    arrkey.forEach(item => {
                                        if (item === 'forwarder_warehouse_name') {
                                            needAdd = false
                                        }
                                    })
                                }

                                keys = this.handleRender(h, row, arrkey, delArr, [], needAdd)
                            }
                            break;
                            // // 报价
                            // case 4:
                            //     break;
                            // // 报价确认
                            // case 5:
                            //     break;
                            // 确认订舱
                            case 7:
                            {
                                // 不显示币种
                                let delArr = ['currency']
                                let needAdd = false
                                if (this.logisticsType === 'transfer') {
                                    needAdd = true
                                    arrkey.forEach(item => {
                                        if (item === 'forwarder_warehouse_name') {
                                            needAdd = false
                                        }
                                    })
                                }
                                keys = this.handleRender(h, row, arrkey, delArr, [], needAdd)
                            }
                            break;
                            // // 订舱
                            // case 8:
                            //     break;
                            // 已订舱
                            case 9:
                            {
                                let delArr = [
                                    'extra_logistics_no',
                                ]
                                keys = this.handleRender(h, row, arrkey, delArr)
                            }
                            break;
                            // // 已报关
                            // case 10:
                            // break;
                            // // 已开船
                            // case 11:
                            //     break;
                            // // 已到港
                            // case 12:
                            //     break;
                            // // 已清关
                            // case 13:
                            //     break;
                            // // 入仓
                            // case 14:
                            //     break;
                            // // 中转仓到达
                            // case 15:
                            //     break;
                            // // 目的仓到达
                            // case 16:
                            //     break;
                            // // 预约送仓
                            // case 17:
                            //     break;
                            // // 仓库到达
                            // case 18:
                            //     break;
                            // // 发票上传
                            // case 19:
                            //     break;
                            // // 发票确认
                            // case 20:
                            //     break;
                            // // 中转已预约
                            // case 21:
                            //     break;
                            // // 报价
                            // case 30:
                            //     break;
                            // // 上传报关单据
                            // case 31:
                            //     break;
                            // // 取消订单
                            // case 32:
                            //     break;
                            // // 恢复异常
                            // case 33:
                            //     break;
                            // // 实际运费录入
                            // case 34:
                            //     break;
                            // // 其他货代目的仓到达
                            // case 35:
                            //     break;
                            // // 单据验收
                            // case 36:
                            //     break;
                            // // 备注
                            // case 40:
                            //     break;
                            // // 确认发货
                            // case 41:
                            //     break;
                            // // 查验
                            // case 42:
                            //     break;
                            // 其他货代-审核
                            case 43:
                            {
                                let delArr = [
                                    'extra_logistics_no',
                                ]

                                let needAdd = false
                                if (this.logisticsType === 'transfer' && this.carrierType === 1) {
                                    needAdd = true
                                    arrkey.forEach(item => {
                                        if (item === 'forwarder_warehouse_name') {
                                            needAdd = false
                                        }
                                    })
                                }
                                keys = this.handleRender(h, row, arrkey, delArr, [], needAdd)
                            }
                            break;
                            // 审核拒回
                            // case 50:
                            // {
                            //     keys = this.handleRender(h, row, arrkey)
                            // }
                            // break
                            default: {
                                keys = this.handleRender(h, row, arrkey)
                            }
                        }
                        return <div>{keys}</div>;
                    }
                },
                {
                    title: this.$t('fbb.headlogistics.attachment', { defaultValue: "附件" }),
                    key: "receivedQty",
                    render: (h, { row }) => {
                        let arrkeyList = [];
                        // additionData
                        if (row.meta) {
                            let jsonone = JSON.parse(row.meta);
                            // arrkeyList = ["order_url","declare_invoice_url","packing_url","sail_order_url","clear_packing_list_url","clear_invoice_url","clear_shipping_label_url","check_order_url","invoice_url", 'sail_order_url', 'invoice_url', 'order_url'].map(val=>{
                            // 	for(var key in jsonone){
                            // 		if(key == val){
                            // 			return h('div', [
                            // 				h('a', {
                            // 					props: {
                            // 						type: "primary",
                            // 						size: 'small'
                            // 					},
                            // 					style: {
                            // 						marginRight: '5px'
                            // 					},
                            // 					on: {
                            // 						click: () => {
                            // 							this.handleDownload(jsonone[key])
                            // 						}
                            // 					}
                            // 				}, this.$t('global.common.download',{defaultValue:'下载'})),
                            // 			])
                            // 		}
                            // 	}
                            // })
                            row.logisticsRecordattachEntities.map(item => {
                                if (item.attachUrl) {
                                    arrkeyList.push(
                                        h("div", [
                                            h(
                                                "a",
                                                {
                                                    props: {
                                                        type: "primary",
                                                        size: "small"
                                                    },
                                                    style: {
                                                        marginRight: "5px"
                                                    },
                                                    on: {
                                                        click: () => {
                                                            this.handleDownload(
                                                                item.attachUrl
                                                            );
                                                        }
                                                    }
                                                },
                                                item.attachName
                                            )
                                        ])
                                    );
                                }
                            });

                            return <div>{arrkeyList}</div>;
                        }
                    }
                }
            ];
        }
    },
    watch: {
        orderid(val, old) {
            if (val) {
                this.update();
            }
        }
    },
    methods: {
        update() {
            // 查看单条的物流信息
            // orderid
            if (this.boxtype == "inbound") {
                HttpInboundHeadLogistics({
                    subLgNo: this.orderid
                }).then(
                    res => {
                        // console.log(res.data)
                        this.formData = res.data;
                        this.dataList = res.data.logisticsRecordEntities || [];
                        this.inboundList =
                            res.data.subLogisticsHistoryParams || [];
                    },
                    err => {
                        this.$VMessage.error(err.message);
                    }
                );
                HttpInboundSubscribe({orderNo: this.orderid
                }).then(
                    res => {
                        this.inboundNodeList = res.data;
                    },
                    err => {
                        this.$VMessage.error(err.message);
                    }
                )
            } else {
                HttpSeeLogisticsOne({
                    orderId: this.orderid
                }).then(res => {
                    this.logisticsType = res.data.logisticsType
                    this.carrierType = res.data.carrierType
                })
                HttpSeeLogisticsHistory({
                    orderId: this.orderid
                }).then(
                    res => {
                        // console.log(res.data)
                        this.formData = res.data;
                        this.dataList = res.data.logisticsRecordEntities || [];
                        this.inboundList =
                            res.data.subLogisticsHistoryParams || [];
                    },
                    err => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        handleRender (
            h,
            row = {},
            arrkey = [],
            delArr = [],
            handleArr = [],
            need = false,
            commonHandle = (key, value) => {
                if (this.keyList[key] === undefined){
                    return
                }
                return <div>{this.keyList[key]}:{value}</div>
            },
            // customHandle = (vEle, arrkey) => {
            //     return vEle
            // }
        ) {
            let vEle = []

            delArr.map(item => {
                arrkey.delete(item)
            })
            arrkey.forEach((item) => {
                let vItem
                let value = ''
                let notRender = new Set()
                let hasRenderd = false
                if (item === 'logistics_type') {
                    hasRenderd = true
                    value = <div>{this.keyList[item]}:{this.getLogisticsType(row.additionData[item])}</div>
                }
                else if (item === 'transport_type') {
                    hasRenderd = true
                    value = <div>{this.keyList[item]}:{this.getTransportType(row.additionData[item])}</div>
                }
                // else if (item === 'extra_audit_action') {
                //     hasRenderd = true
                //     value = <div>{this.keyList[item]}:{this.getAction(row.additionData[item])}</div>
                // }
                else if (item === 'ship_port_id') {
                    hasRenderd = true
                    // 为string直接展示
                    if (typeof(row.additionData[item]) === 'string') {
                        value = <div>{this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' })}：{row.additionData[item]}</div>
                    }
                }
                else if (item === 'importer_id') {
                    hasRenderd = true
                    value = <div></div>
                    // 为string直接展示
                    if (typeof(row.additionData[item]) === 'string') {
                        value = <div>{this.$t('fbb.headlogtics.importer', { defaultValue: '进口商' })}：{row.additionData[item]}</div>
                    }
                }
                else if (item === 'inbounds') {
                    hasRenderd = true
                    row.additionData[item].map(sItem => {
                        value = row.additionData[item].map(sItem => {
                            let keyArr = Object.keys(
                                sItem.data
                            );
                            let itemEle = keyArr.map(tItem => {
                                return (
                                    <div>
                                        {this.keyList[tItem]}:
                                        {sItem.data[tItem]}
                                    </div>
                                );
                            });
                            return (
                                <div>
                                    <div>
                                        {this.$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })}: {sItem.id}
                                    </div>
                                    {itemEle}
                                </div>
                            );
                        });
                    })
                }
                else if (item === 'order_src' || item === 'sail_order_src' || item === 'invoice_src' || item === 'pod_src') {
                    let urlKey = item.replace('src', 'url')
                    hasRenderd = true
                    if (!row.additionData[item]) {
                        return
                    }
                     value = h("div", [
                                h('span', `${this.keyList[item]}：`),
                                h("a",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        attrs: {
                                            target: '_blank',
                                            href: row.additionData[urlKey],
                                            download: row.additionData[item],
                                        },
                                        // on: {
                                        //     click: () => {
                                        //         this.handleDownload(
                                        //             row.additionData[urlKey]
                                        //         );
                                        //     }
                                        // }
                                    }, row.additionData[item])])
                }
                handleArr.map(handleItem => {
                    if (item === handleItem.name) {
                        value = handleItem.handle(item, row.additionData[item])
                        hasRenderd = true
                    }
                })
                if (!hasRenderd) {
                    value = commonHandle(item, row.additionData[item])
                }
                // console.log(item, this.keyList[item], row.additionData[item])
                // console.log(value)
                vItem = <div>{value}</div>
                vEle.push(vItem)
            })
            if (need) {
                vEle.push(<div>{this.$t('fbb.headlogistics.forwarder_warehouse_name', { defaultValue: '中转仓名称' })}：Other</div>)
            }
            return vEle
        },
        handleDownload(url) {
            // console.log(url)
            this.handleWebfs(url, "download");
        },
        getAction (type) {
            let arr = [{
                value: 0,
                label: this.$t('fbb.headlogistics.shenhejuhui', { defaultValue: '审核拒回' })
            }, {
                value: 1,
                label: this.$t('fbb.inbound.pass_audit', { defaultValue: '审核通过' })
            }]
            return arr.filter(item => {
                return type === item.value
            })[0].label
        },
        getTransportType (type) {
            // try {
                let a = this.gettransportType.filter(item => {
                    return type == item.value
                })[0]
                if (!a) {
                    return '--'
                }
                else {
                    return a.label
                }
            // }
            // catch (err) {
            //     return '--'
            // }
        },
        getLogisticsType (type) {
            return this.logisticsTypeList.filter(item => {
                return type === item.value
            })[0].label
        },
        getLogistics(type) {
            if (type === undefined) return "";
            let btnItem =
                this.btnList.filter(item => {
                    return type === item.type;
                })[0] || {};
            return btnItem.text ? btnItem.text : "";
            // switch(type){
            // 	case 0: return '初始化'; break;
            // 	case 1: return '待订舱'; break;
            // 	case 2: return '已订舱'; break;
            // 	case 3: return '已报关'; break;
            // 	case 4: return '已发船'; break;
            // 	case 5: return '已到港'; break;
            // 	case 6: return '已清关'; break;
            // 	case 7: return '中转仓到达'; break;
            // 	case 8: return '已打托'; break;
            // 	case 9: return '已预约'; break;
            // 	case 10: return '已妥投'; break;
            //     case 11: return '查验中'; break;
            //     case 0: return '初始化'; break;
            // }
        },
        getOrderstatus(type) {
            return this.queryOrderStatusList.filter(item => {
                return type == item.value
            })[0].label || '--'
            // switch (type) {
            //     // case 0: return '已创建'; break;
            //     // case 1: return '已提交'; break;
            //     // case 2: return '已退回'; break;
            //     // case 3: return '已审批'; break;
            //     // case 4: return '报价已确认'; break;
            //     // case 5: return '已取消'; break;
            //     // case 6: return '已确认订舱'; break;
            //     // case 7: return '已发运'; break;
            //     // case 8: return '已到达'; break;
            //     // // case 10: return '草稿状态'; break;
            //     // case 11: return '验收关闭'; break;
            //     case 0:
            //         return "已创建";
            //         break;
            //     case 1:
            //         return "待审核";
            //         break;
            //     case 2:
            //         return "已退回";
            //         break;
            //     case 3:
            //         return "待确认订舱";
            //         break;
            //     case 4:
            //         return "报价已确认";
            //         break;
            //     case 5:
            //         return "已取消";
            //         break;
            //     case 6:
            //         return "待订舱";
            //         break;
            //     case 7:
            //         return "待清关";
            //         break;
            //     case 8:
            //         return "待预约";
            //         break;
            //     case 10:
            //         return "草稿";
            //         break;
            //     case 11:
            //         return "验收关闭";
            //         break;
            //     case 14:
            //         return "待发船";
            //         break;
            //     case 15:
            //         return "待到港";
            //         break;
            //     case 16:
            //         return "待妥投";
            //         break;
            //     case 17:
            //         return "已妥投";
            //         break;
            //     case 18:
            //         return "中转待送仓";
            //         break;
            //     case 19:
            //         return "待报关";
            //         break;
            // }
        }
    }
};
</script>

